import CommentService from '@/service/comment'
export default {
  getListCommentOfChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CommentService.getListCommentOfChecklistItem(payload.checklist, payload.checklist_item).then(res => {
        commit('getListCommentOfChecklistItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createCommentOfChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CommentService.createCommentOfChecklistItem(payload.checklist, payload.checklist_item, payload.comment).then(res => {
        // commit('createCommentOfChecklistItem', res.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyCommentOfChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CommentService.destroyCommentOfChecklistItem(payload.checklist, payload.checklist_item, payload.comment).then(res => {
        // commit('createCommentOfChecklistItem', res.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  showCommentOfChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CommentService.showCommentOfChecklistItem(payload.checklist, payload.checklist_item, payload.comment).then(res => {
        // commit('createCommentOfChecklistItem', res.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateCommentOfChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CommentService.updateCommentOfChecklistItem(payload.checklist, payload.checklist_item, payload.comment).then(res => {
        // commit('createCommentOfChecklistItem', res.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  setCommentIsFinal ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CommentService.setCommentIsFinal(payload.comment).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  attachFileInComment ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CommentService.attachFile(payload.file).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/comment/actions.js